import { setPageContent } from "..";
import { t } from "../locale";
import { Bulma } from "./bulma";
import { centeredBox } from "./components";

function notFoundPage() {
	setPageContent(
		centeredBox(
			"small",
			t.pageNotFound,
			Bulma.buttons(
				Bulma.button(
					{
						onClick: () => window.history.back(),
						styles: ["is-primary"],
					},
					t.back,
				),
			),
		),
	);
}

export { notFoundPage };
